// extracted by mini-css-extract-plugin
export var cAlignedLeft = "styles-module--c-aligned-left--d8f05";
export var cContainer = "styles-module--c-container--67432";
export var cIsBoxed = "styles-module--c-is-boxed--06ae8";